<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Alta de Pacientes por Convenio</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Carga_Convenios</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos"> Alta de Pacientes por Convenio Masivo</b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">
            <b-col class="col-6">
              <b-form-group align="left">
                <label for="empresa">Empresa</label>
                  <v-select
                      label="nombreComercial"
                      id="compania"
                      v-model="compania"
                      :options="lstCompania"
                      @input="seleccinarEmpresa($event)"
                      required
                  >
                    <span slot="no-options">No hay datos...</span>
                  </v-select>
              </b-form-group>
            </b-col>
            <b-col class="col-6">
              <b-form-group align="left">
                <label for="plan">Planes</label>
                  <v-select
                      label="nombrePlan"
                      id="plan_convenio"
                      v-model="planConvenio"
                      :options="lstPlanesConvenios"
                      required
                      :disabled="compania === null"
                  >
                    <span slot="no-options">No hay datos...</span>
                  </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col size="6">
          <b-form-group align="left">
            <label for="plan">Archivo</label>
            <b-form-file v-model="archivo" placeholder="Seleccionar archivo" browse-text="Abrir" type="file" @change="cargarArchivo($event)" ref="inputFile"></b-form-file>
            <b-form-text id="password-help-block">
              El archivo de carga de pacientes debe tener los siguientes datos en el orden establecido( La columna correspondiente esta entre parentesis):

              <ul>
                <li>(A) Plan Dental<small>(Opcional) </small></li>
                <li>(B) Fecha de Solicitud<small>(Opcional) </small></li>
                <li>(C) Contratante<small>(Opcional) </small></li>
                <li>(D) No. Póliza*</li>
                <li>(E) No. Certificado*</li>
                <li>(F) Nombre del Paciente<small>(Opcional) </small></li>
                <li>(G) Clinica<small>(Opcional) </small></li>
                <li>(H) Nombre del Anfitrión <small>(Opcional) </small></li>
                <li>(I) Fecha Inicio de Vigencia* </li>
                <li>(J) Fecha Fin de Vigencia*</li>
              </ul>

              <br>
              <p class="nota"><small>Nota: revisar que las fechas ingresadas en el archivo tengan formato <strong>FECHA</strong>
                <br>
                * El archivo no debe tener ningún tipo de margen.<br>
                * Verificar que el nombre de las columnas no lleve espacios al inicio y al final,
                <br>tampoco caracteres especiales o tildes.
              </small></p>

              <a href="/files/formato-convenio.xlsx" download> Descargar Formato</a>

            </b-form-text>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
    <b-row class="mb-2">
        <b-col>
          <b-button variant="primary" @click="validar" :disabled="loader">
            <span v-if="!loader">Guardar</span>
            <span v-if="loader">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span> </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-table
            id="Pacientes"
            thead-tr-class="columnas"
            :items="pacientes"
            :fields="fields"
            responsive="true"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            class="parrafos"
            fixed
        >
          <template v-slot:cell(fechaSolicitud)="row">
            {{ row.item.fechaSolicitud | formatoFechaCorta }}
          </template>
          <template v-slot:cell(fechaInicio)="row">
            {{ row.item.fechaInicio | formatoFechaCorta }}
          </template>
          <template v-slot:cell(fechaFin)="row">
            {{ row.item.fechaFin | formatoFechaCorta }}
          </template>
          <template v-slot:cell(index)="row">
            {{ row.index +1}}
          </template>
        </b-table>
         <b-pagination
              v-if="pacientes.length > 1"
              align="center"
              v-model="paginaActual"
              :total-rows="pacientes.length"
              :per-page="registrosPorPagina"
          ></b-pagination>
      </b-row>
      <br>
      <br>
      <b-row v-if="resultado.length > 0">
        <b-table
            id="Pacientes"
            thead-tr-class="columnas"
            :items="resultado"
            :fields="fieldRespuesta"
            responsive="true"
            class="parrafos"
            fixed
        >

          <template v-slot:cell(estatus)="row">

            <b-badge v-if="row.item.estatus" variant="primary">
              Actualizado
            </b-badge>
            <b-badge v-else variant="success">
              Nuevo
            </b-badge>
          </template>
          <template v-slot:cell(index)="row">
            {{ row.index +1}}
          </template>
        </b-table>
      </b-row>
      <br>
      <br>
      <br>
      <br>
    </b-container>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import Header from "@/components/Header";
import moment from "moment";
export default {
  name: "AltaPacientesBbva",
  components: {
    Header,
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      compania: null,
      loader: false,
      planConvenio: null,
      archivo: null,
      lstCompania: [],
      lstPlanesConvenios: [],
      file: [],
      lista: [],
      pacientes: [],
      resultado: [],
      registrosPorPagina: 10,
      paginaActual: 1,
      fields: [
        { key: "index", label: "Num.", sortable: true },
        { key: "planDental", label: "Plan Dental", sortable: true },
        { key: "fechaSolicitud", label: "Fecha de Solicitud", sortable: true },
        { key: "contratante", label: "Contratante", sortable: true },
        { key: "numeroPoliza", label: "No. Póliza", sortable: true },
        { key: "numeroCertificado", label: "No. Certificado", sortable: true },
        { key: "nombrePaciente", label: "Nombre del Paciente", sortable: true },
        { key: "clinica", label: "Clinica", sortable: true },
        { key: "nombreAnfitrion", label: "Nombre del Anfitrión", sortable: true },
        { key: "fechaInicio", label: "Fecha Inicio de Vigencia", sortable: true },
        { key: "fechaFin", label: "Fecha Fin de Vigencia", sortable: true },
        
      ],
      fieldRespuesta: [
        { key: "index", label: "Num.", sortable: true },
        { key: "numeroCertificado", label: "No. Certificado", sortable: true },
        { key: "fechaSolicitud", label: "Fecha de Solicitud", sortable: true },
        { key: "estatus", label: "Estatus", sortable: true }
      ],
    }
  },
  mounted() {
    this.alerta();
    this.obtenerListaEmpresas();
  },
  methods: {
    obtenerListaEmpresas() {
      this.$http
          .get(this.$api + "empresas/obtener")
          .then((response) => {
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstCompania = [];
              resultado.forEach((item, index) => {
                item.id = index;
                this.lstCompania.push(item);
              });
            }
          })
          .catch(function (error) {
            console.error(error);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          });
    },

    obtenerPlanesEmpresa(empresa) {
      // this.loaderPlanes = true;
      this.planConvenio = null;
      const parametros = {idEmpresa: empresa.idEmpresa}
      var url = "empresas/obtener/beneficios/empresa";

      this.$http
          .post(
              this.$api + url, parametros
          )
          .then((response) => {
            // this.loaderPlanes = false;
            if (response.data.data) {
              let resultado = response.data.data;
              this.lstPlanesConvenios = [];
              resultado.forEach((item, index) => {
                item.id = index;
                this.lstPlanesConvenios.push(item);
              });
            }
          })
          .catch(function (error) {
            // this.loaderPlanes = false;
            console.error(error);
            this.$swal({
              icon: "error",
              text: "A ocurrido un error, intentalo más tarde.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          })
          .finally(() => {
            this.plan_convenio = true;
          });
    },

    seleccinarEmpresa(evento) {
      this.lstPlanesConvenios = [];
      this.planConvenio = null;
      this.plan_convenio = false;
      this.obtenerPlanesEmpresa(evento);
    },
    
    cargarArchivo(e) {
     this.loader = true;
      this.resultado = [];
      this.pacientes = [];
      const files = e.target.files;
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        const data = ev.target.result;
        const workbook = XLSX.read(data, {
          type: "binary" // binary
        });
        const wsname = workbook.SheetNames[0];
        this.lista = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);
        if (this.lista.length == 0) {
          this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: "No hay datos en el documento!",
            })
            this.archivo = null;
             this.loader = false;
             this.$refs.inputFile.reset();
            return false;
        }
      for (let value of this.lista) {
         if (value["NO. POLIZA"] === undefined || value["NO. CERTIFICADO"] === undefined || value["INICIO DE VIGENCIA"] === undefined || value["FIN DE VIGENCIA"] === undefined){
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: "El formato no cumple con los campos requeridos en un registro",
            })
            this.$refs.inputFile.reset();
            this.loader = false;
            return false;
          }
          const fechaS =  new Date((value["FECHA DE SOLICITUD"] - (25567 + 1))*86400*1000);
          const fechaSolicitud = new Date(fechaS.getFullYear(), fechaS.getMonth() , fechaS.getDate(), 8, 0, 0, 0);
          const fechai = value["INICIO DE VIGENCIA"] != undefined ? new Date((value["INICIO DE VIGENCIA"] - (25567 + 1))*86400*1000): null;
          const fechaf =  value["FIN DE VIGENCIA"] != undefined ? new Date((value["FIN DE VIGENCIA"] - (25567 + 1))*86400*1000): null;
          const fechaInicio = fechai != null ? new Date(fechai.getFullYear(), fechai.getMonth() , fechai.getDate(), 8, 0, 0, 0): null;
          const fechaFin = fechaf != null ? new Date(fechaf.getFullYear(), fechaf.getMonth() , fechaf.getDate(), 8, 0, 0, 0): null;
          const pat = {
            fechaSolicitud: fechaSolicitud != 'Invalid Date' ? fechaSolicitud : null,
            contratante: value["CONTRATANTE"],
            numeroPoliza: value["NO. POLIZA"],
            numeroCertificado: value["NO. CERTIFICADO"],
            nombrePaciente: value["NOMBRE DEL PACIENTE"],
            clinica: value["CLINICA"],
            nombreAnfitrion: value["NOMBRE DEL ANFITRION"],
            fechaInicio: fechaInicio,
            fechaFin: fechaFin,
            
          }
          this.pacientes.push(pat);

        }
        this.guardar();
       };
       fileReader.readAsBinaryString(files[0]);
    },

    validar() {
      if(this.compania === null || this.planConvenio === null || this.pacientes.length == 0){
        this.pacientes = [];
        this.lista = [];
        this.loader = false;
        this.archivo = null;
        
      
      if(this.compania === null){
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Seleccione una empresa",
        })
        
        return false;
      }

      if(this.planConvenio === null){
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Seleccione un plan",
        })
        return false;
      }

      if(this.pacientes.length === 0){
        this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "No hay ningún archivo cargado con pacientes.",
        })
        return false;
      }
      }
    },

    guardar(){
      this.validar();
      this.$http.post(this.$api + "planConvenio/convenio-masivo?idEmpresa="+this.compania.idEmpresa+"&idPlan="+this.planConvenio.idPlan, this.pacientes).then((respuesta) => {
        if (respuesta.data.data) {
         let datos = {
            nuevos: null,
            encontrados: null,
            lista : []
          };
          datos = respuesta.data.data;
          this.$swal.fire({
            icon: "success",
            title: "Aviso",
          html:'<p>Datos guardados correctamente!</p>' +
                '<br>' +
                '<p><label>Registros Nuevos: </label><span>'+datos.nuevos+' </span></p>' +
                '<label>Registros encontrados: </label><span> '+datos.encontrados+' </span>' ,
          });

           this.resultado = [];

          datos.lista.map(value => {
            value.fechaSolicitud =  moment(value.fechaSolicitud)
                .utc()
                .format("DD/MM/YYYY");

            this.resultado.push(value)
          })
         
          this.resultado = datos.lista;
          this.pacientes = [];
          this.compania = null;
          this.planConvenio = null;
          this.archivo = null;
        }
      }).finally(()=> {
        this.loader = false;
      });
    },

    alerta(){
      this.$swal.fire({
          icon: "info",
          title: "Aviso",
          text: "Verificar que el archivo a subir cumpla con los campos obligatorios.",
      })
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>
  .nota{
    color: #842511;
  }
</style>
